// hooks/useDateFormatter.ts
import { useCallback } from 'react';
import { format, parseISO, isValid } from 'date-fns';
import firebase from 'firebase/compat/app';

export const useDateFormatter = () => {
  const formatProposedDate = useCallback((date: string | Date | firebase.firestore.Timestamp | undefined): string => {
    if (!date) return '';

    try {
      if (typeof date === 'string') {
        const parsedDate = parseISO(date);
        if (isValid(parsedDate)) {
          return format(parsedDate, 'MMM dd, yyyy');
        }
        const fallbackDate = new Date(date);
        if (isValid(fallbackDate)) {
          return format(fallbackDate, 'MMM dd, yyyy');
        }
      } else if (date instanceof Date) {
        if (isValid(date)) {
          return format(date, 'MMM dd, yyyy');
        }
      } else if (date instanceof firebase.firestore.Timestamp) {
        const timestampDate = date.toDate();
        if (isValid(timestampDate)) {
          return format(timestampDate, 'MMM dd, yyyy');
        }
      }
      throw new Error(`Invalid date value: ${date}`);
    } catch (error) {
      console.error('Error formatting date:', error, 'Date value:', date);
      return '';
    }
  }, []);

  return { formatProposedDate };
};